import React from 'react';
import { Tooltip } from '@mantine/core';
import { type ProgressStatus } from '@/models/types';

interface ProgressIndicatorProps {
  status: ProgressStatus;
  size?: number;
  showTooltip?: boolean;
}

const statusConfig = {
  not_started: {
    color: '#ff6b6b',
    label: 'Not Started',
    description: 'This section has not been started yet',
  },
  in_progress: {
    color: '#ffd43b',
    label: 'In Progress',
    description: 'This section is currently being worked on',
  },
  completed: {
    color: '#51cf66',
    label: 'Completed',
    description: 'This section has been completed',
  },
  complete: {
    color: '#51cf66',
    label: 'Completed',
    description: 'This section has been completed',
  },
};

export const ProgressIndicator = React.memo(({ 
  status, 
  size = 12, 
  showTooltip = true 
}: ProgressIndicatorProps) => {
  const validStatus = status && status in statusConfig ? status : 'not_started';
  const config = statusConfig[validStatus as keyof typeof statusConfig];
  
  const indicator = (
    <div
      className="progress-indicator"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        backgroundColor: config.color,
        transition: 'all 0.3s ease',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        flexShrink: 0,
        display: 'inline-block',
      }}
    />
  );

  if (showTooltip) {
    return (
      <Tooltip 
        label={config.label} 
        withArrow
        openDelay={200}
      >
        {indicator}
      </Tooltip>
    );
  }

  return indicator;
});